import React, { useState, createContext } from 'react'
import { LOAD_PRIVACY, LOAD_TERMS } from 'AccountsConstants/routes'
import {
  TERMS_OF_USE_HEADER,
  PRIVACY_POLICY_HEADER,
} from 'AccountsConstants/language/account'

export const LegalContext = createContext({
  legalOpts: []
})

export const LegalState = ({ children }) => {
  const [legalOpts] = useState([
    {
      label: TERMS_OF_USE_HEADER,
      link: LOAD_TERMS
    },
    {
      label: PRIVACY_POLICY_HEADER,
      link: LOAD_PRIVACY
    }
  ])

  return (
    <LegalContext.Provider
      value={{
        legalOpts
      }}
    >
      {children}
    </LegalContext.Provider>
  )
}
